import { VisibilityOffOutlined, VisibilityOutlined } from "@mui/icons-material";
import { InputAdornment, TextField } from "@mui/material";
import { useEffect, useState } from "react";

const InputPasswordComponent = ({
  error,
  name,
  onChange,
  placeholder,
  value,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState(value);

  useEffect(() => {
    setPassword(value);
  }, [value]);

  useEffect(() => {
    onChange(password);
  }, [onChange, password]);

  const toggleShowPassword = () => setShowPassword((show) => !show);

  return (
    <TextField
      error={error}
      InputProps={{
        endAdornment: (
          <InputAdornment
            className='cursor-pointer'
            position='end'
            onClick={toggleShowPassword}
          >
            {showPassword ? <VisibilityOutlined className="!text-[#5F737F]" /> 
            : <VisibilityOffOutlined className="!text-[#5F737F]"/>}
          </InputAdornment>
        ),
      }}
      name={name}
      placeholder={placeholder}
      type={showPassword ? "text" : "password"}
      value={password}
      onChange={(e) => setPassword(e.target.value)}
    />
  );
};

export default InputPasswordComponent;
